/* KittySupps taurine PDP clone (2026-10-20). Behaviour copied from kittysupps.com/products/taurine:
   Kaching-style tier picker + Subscribe & Save + progressive gifts, stock pill, delivery date, review slider,
   sticky ATC bar, scroll-to-top, results count-up, promo popup and the cart drawer timer. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (n) { return '$' + Number(n).toFixed(2); };

  /* ---------- Tier picker (Kaching look) ---------- */
  function initPicker(root) {
    var cfg = JSON.parse($('script[type="application/json"]', root).textContent);
    var form = document.getElementById(root.dataset.form);
    var bars = $$('.ks-kb__bar', root);
    var gifts = $$('.ks-kb__gift', root);

    function select(i) {
      bars.forEach(function (b, j) { b.classList.toggle('is-selected', i === j); $('input', b).checked = i === j; });
      var qty = cfg.tiers[i].qty;
      gifts.forEach(function (g) {
        var open = qty >= Number(g.dataset.unlock);
        g.classList.toggle('is-locked', !open);
      });
      root.dataset.selected = i;
      // sticky bar: the chosen tier's total, its compare-at and the saving, already formatted for this market
      var t = cfg.tiers[i];
      $$('.ks-sticky-atc__now').forEach(function (e) { e.textContent = t.price; });
      $$('.ks-sticky-atc__was').forEach(function (e) { e.textContent = t.compare; e.hidden = !t.pct; });
      $$('.ks-sticky-atc__pct').forEach(function (e) { e.textContent = t.pct; });
      $$('.ks-sticky-atc__save').forEach(function (e) { e.hidden = !t.pct; });
      if (form) { var idIn = form.querySelector('input[name="id"]'); if (idIn) { idIn.value = cfg.tiers[i].variant; idIn.disabled = false; } }
    }
    bars.forEach(function (b, i) { b.addEventListener('click', function () { select(i); }); });
    // Like theirs: clicking a locked gift selects the tier that unlocks it
    gifts.forEach(function (g) { g.addEventListener('click', function () { if (g.classList.contains('is-locked')) select(Number(g.dataset.unlock) - 1); }); });
    select(Number(root.dataset.default || 0));

    // Buy button: empty the cart, add the tier variant plus the gifts it unlocks, then straight to checkout. The cart is
    // never shown (Roberto 2026-10-22: "the atc button should go straight to checkout. never cart visible"). Emptying
    // first keeps an earlier visit's tier out of this checkout
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault(); e.stopImmediatePropagation();
      var i = Number(root.dataset.selected), t = cfg.tiers[i];
      var btn = form.querySelector('[type="submit"]');
      if (btn.getAttribute('aria-disabled') === 'true') return;
      btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading');
      var spin = form.querySelector('.loading__spinner'); if (spin) spin.classList.remove('hidden');
      var items = [{ id: t.variant, quantity: 1, properties: { _bundle: t.title } }];
      cfg.gifts.forEach(function (g) { if (g.variant && t.qty >= g.unlock) items.push({ id: g.variant, quantity: 1, properties: { _bundle: t.title, _gift: 'true' } }); });
      var base = window.Shopify.routes.root, json = { 'Content-Type': 'application/json', Accept: 'application/json' };
      var done = function () { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); if (spin) spin.classList.add('hidden'); };
      fetch(base + 'cart/clear.js', { method: 'POST', headers: json })
        .then(function () { return fetch(base + 'cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: items }) }); })
        .then(function (r) { return r.json(); }).then(function (res) {
          if (res.status) { alert(res.description || res.message); done(); return; }
          location.href = base + 'checkout';  // the spinner stays on until the checkout page loads
        }).catch(function (err) { alert(err.message); done(); });
    }, true);
  }

  /* ---------- Header cart icon: never opens the cart. Something in it: go to checkout; empty: scroll to the tiers ---------- */
  function initCartIcon() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('#cart-icon-bubble'); if (!a) return;
      e.preventDefault(); e.stopImmediatePropagation();
      fetch(window.Shopify.routes.root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
        if (c.item_count > 0) { location.href = window.Shopify.routes.root + 'checkout'; return; }
        var picker = $('[data-ks-picker]');
        if (picker) picker.scrollIntoView({ behavior: 'smooth', block: 'center' }); else location.href = a.href.replace(/\/cart$/, '/products/taurine-supplement');
      });
    }, true);
  }

  /* ---------- Results rings draw 650 ms after scrolling into view ---------- */
  function initRings() {
    var rings = $$('.ks-res__ring circle[data-pct]'); if (!rings.length) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return; io.unobserve(e.target);
        setTimeout(function () { e.target.setAttribute('stroke-dasharray', e.target.dataset.pct + ' 100'); }, 650);
      });
    }, { threshold: .3 });
    rings.forEach(function (r) { io.observe(r); });
  }

  /* ---------- Delivery date: today + 3 days, "October 23rd" ---------- */
  function initDelivery() {
    $$('[data-ks-delivery]').forEach(function (el) {
      var d = new Date(); d.setDate(d.getDate() + Number(el.dataset.ksDelivery || 3));
      var day = d.getDate(), s = (day % 10 === 1 && day !== 11) ? 'st' : (day % 10 === 2 && day !== 12) ? 'nd' : (day % 10 === 3 && day !== 13) ? 'rd' : 'th';
      el.textContent = d.toLocaleString('en-US', { month: 'long' }) + ' ' + day + s;
    });
  }

  /* ---------- Simple slider (buy-box reviews, FB testimonials on phones) ---------- */
  function initSlider(root) {
    var track = $('.ks-slider__track', root), slides = $$('.ks-slider__slide', root), dots = $$('.ks-slider__dot', root);
    var i = 0, timer;
    function go(n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (-100 * i) + '%)';
      // FB slider on phones: the window takes the height of the card on show (like theirs), not the tallest card
      if (root.dataset.adaptive !== undefined) { var vp = track.parentElement; vp.style.height = window.matchMedia('(max-width: 749px)').matches ? slides[i].offsetHeight + 'px' : ''; }
      dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
      var prev = $('.ks-slider__prev', root); if (prev) prev.disabled = !root.dataset.loop && i === 0;
      var next = $('.ks-slider__next', root); if (next) next.disabled = !root.dataset.loop && i === slides.length - 1;
    }
    dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); restart(); }); });
    var p = $('.ks-slider__prev', root), nx = $('.ks-slider__next', root);
    if (p) p.addEventListener('click', function () { go(i - 1); restart(); });
    if (nx) nx.addEventListener('click', function () { go(i + 1); restart(); });
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); restart(); }
    });
    function restart() { if (!root.dataset.autoplay) return; clearInterval(timer); timer = setInterval(function () { go(i + 1); }, Number(root.dataset.autoplay)); }
    go(0); restart();
  }

  /* ---------- Sticky add-to-cart bar: shows once the main ATC button has scrolled out of view ---------- */
  function initSticky() {
    // watch the real ATC button (an empty marker div is display:none in Dawn, so it never intersects)
    var bar = $('.ks-sticky-atc'), main = $('form[data-type="add-to-cart-form"] .product-form__submit'); if (!bar || !main) return;
    document.body.appendChild(bar);  // out of the product column: an animated (transformed) parent would pin "fixed" to itself
    new IntersectionObserver(function (es) {
      var e = es[0]; bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(main);
    $('.ks-sticky-atc__btn', bar).addEventListener('click', function () {
      var f = document.querySelector('form[data-type="add-to-cart-form"]');
      if (f) f.requestSubmit ? f.requestSubmit() : f.submit();
    });
  }

  /* ---------- Scroll-to-top button ---------- */
  function initToTop() {
    var b = $('.ks-totop'); if (!b) return;
    var on = function () { b.classList.toggle('is-visible', window.scrollY > 600); };
    window.addEventListener('scroll', on, { passive: true }); on();
    b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* ---------- Cart drawer "Cart reserved for 04:59" countdown (restarts at 5:00 each time the drawer renders) ---------- */
  var resTimer;
  function startReserve() {
    var el = $('[data-ks-reserve]'); if (!el) return;
    clearInterval(resTimer);
    var end = Date.now() + 5 * 60 * 1000;
    var tick = function () {
      var s = Math.max(0, Math.round((end - Date.now()) / 1000));
      var t = $('[data-ks-reserve]'); if (t) t.textContent = String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0');
    };
    tick(); resTimer = setInterval(tick, 1000);
  }
  function watchDrawer() {
    var d = document.getElementById('CartDrawer'); if (!d) return;
    new MutationObserver(function () {
      var t = $('[data-ks-reserve]');  // absent while the cart is empty
      if (t && !t.dataset.started) { t.dataset.started = 1; startReserve(); }
    }).observe(d, { childList: true, subtree: true });
    startReserve();
  }

  /* ---------- Shipping protection toggle in the cart drawer: adds/removes the $5 helper product (off by default like theirs) ---------- */
  document.addEventListener('change', function (e) {
    if (!e.target.matches('.ks-protect__input')) return;
    var input = e.target, on = input.checked, id = Number(input.dataset.variant);
    input.closest('.ks-protect').classList.toggle('is-on', on);
    var root = window.Shopify.routes.root;
    var req = on
      ? fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
      : fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: (function (u) { u[id] = 0; return u; })({}) }) });
    req.then(function () { return fetch(root + '?sections=cart-drawer,cart-icon-bubble'); })
      .then(function (r) { return r.json(); })
      .then(function (sections) { var d = document.querySelector('cart-drawer'); if (d) d.renderContents({ sections: sections }); })
      .catch(function () { input.checked = !on; input.closest('.ks-protect').classList.toggle('is-on', !on); });
  });

  /* ---------- Promo popup (their Klaviyo form): desktop after 7 s or on exit intent, phones after 8 s; once per session ---------- */
  function initPromo() {
    var pop = $('.ks-promo'); if (!pop) return;
    var seen; try { seen = sessionStorage.getItem('ks-promo-seen'); } catch (e) {}
    if (seen || location.search.indexOf('nopopup') > -1) return;
    var opened = false;
    var open = function () { if (opened) return; opened = true; pop.classList.add('is-open'); try { sessionStorage.setItem('ks-promo-seen', 1); } catch (e) {} };
    var close = function () { pop.classList.remove('is-open'); };
    var phone = window.matchMedia('(max-width: 749px)').matches;
    setTimeout(open, phone ? 8000 : 7000);
    if (!phone) document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0) open(); });
    $$('[data-ks-promo-close]', pop).forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pop.classList.contains('is-open')) close(); });
    $('[data-ks-promo-claim]', pop).addEventListener('click', function () { pop.classList.add('is-step2'); });
    // The email is stored as a Shopify customer (newsletter); the page stays put and shows the success step like theirs
    var f = $('form', pop);
    if (f) f.addEventListener('submit', function (e) {
      e.preventDefault();
      fetch(f.action, { method: 'POST', body: new FormData(f) }).catch(function () {});
      pop.classList.remove('is-step2'); pop.classList.add('is-step3');
    });
  }

  // Gallery thumbnails: keep the selected one in the middle of the row, like the dog page (Impact) does. Dawn only
  // scrolls the row when the thumbnail is off-screen, and puts it at the left edge (Roberto 2026-10-22)
  function initThumbs() {
    var list = $('.product__media-wrapper .thumbnail-slider .thumbnail-list');
    if (!list) return;
    var centre = function () {
      var b = $('.thumbnail[aria-current]', list);
      if (!b) return;
      var r = b.getBoundingClientRect(), lr = list.getBoundingClientRect();
      list.scrollTo({ left: list.scrollLeft + (r.left - lr.left) - (list.clientWidth - r.width) / 2, behavior: 'smooth' });
    };
    new MutationObserver(centre).observe(list, { subtree: true, attributes: true, attributeFilter: ['aria-current'] });
  }

  function init() {
    $$('[data-ks-picker]').forEach(initPicker);
    $$('[data-ks-slider]').forEach(initSlider);
    initRings(); initDelivery(); initSticky(); initToTop(); watchDrawer(); initPromo(); initThumbs(); initCartIcon();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
